<template>
  <div class="during-vote">
    <hero-animation class="hero-animation" />
    <animation-button class="vote-button">
      <div class="btn-outer appear-anime" @click="voteBtnClick()">
        <img class="text"
          :src="require(`@images/top/${$route.params.lang}/btn_vote-text.png`)"
          :alt="$t('btn001')"
        >
      </div>
    </animation-button>
    <vote-notice />
    <section class="vote-about">
      <BtnAbout />
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ModelModal from '@models/modal'
import modalNALink from '@components/modals/modal-na-link'
import HeroAnimation from '@components/global/hero-animation.vue'
import AnimationButton from '@components/global/animation-button.vue'
import BtnAbout from '@components/global/button-about.vue'
import VoteNotice from '@components/global/vote-notice.vue'
import localeTop from '@locales/top'

export default {
  name: 'duringVote',
  $messages: localeTop,
  components: {
    HeroAnimation,
    AnimationButton,
    BtnAbout,
    VoteNotice,
  },
  computed: {
    ...mapGetters('login', ['isLogin']),
  },
  methods: {
    ...mapActions('modal', ['showModal']),
    voteBtnClick() {
      if (this.isLogin) {
        this.$router.push(`/${this.$route.params.lang}/select-type`)
        window.scrollTo(0, 0)
      } else {
        this.showModal(new ModelModal({
          component: modalNALink,
          props: {
            isModal: false,
            withoutLogin: `/${this.$route.params.lang}/select-type`,
            redirectTo: `${location.origin}/${this.$route.params.lang}/select-type`,
          }
        }))
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@keyframes btnAppear {
  from {
    opacity: 0;
    transform: scale(2, 5);
  }
  to {
    opacity: 1;
    transform: scale(1, 1);
  }
}
.during-vote {
  > .hero-animation {
    margin-top: -50px;
  }
  > .vote-button {
    margin-top: -90px;
    .btn-outer {
      position: relative;
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 556px;
      height: 198px;
      margin: 0 auto;
      padding: 0;
      background-image: url(#{$img-path}top/btn_vote.png);
      background-repeat: no-repeat;
      background-color: transparent;
      background-position: 50% 0;
      background-size: auto 100%;
      @include tap-event();
    }
    .appear-anime {
      animation-name: btnAppear;
      animation-duration: 100ms;
      animation-timing-function: ease-in;
      animation-delay: 0ms;
    }
  }
  > .vote-about {
    margin-top: 40px;
  }
}
</style>